import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
import { Props } from '../ThumbView';

import s from './Journal.scss';

const JournalThumbReactView: React.FC<Props> = props => (
  <div className={s['root']} style={{ width: props.width, height: props.height }}>
    <MinimalDumbo {...props} />
  </div>
);
JournalThumbReactView.displayName = 'JournalThumbReactView';

export default JournalThumbReactView;
